import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * this service used in development to manage debug,error,info,warning,log output to console
 */
@Injectable({
  providedIn: 'root',
})
export class ConsoleService {
  
  static error(message: string, data: any = null) {
    if (!environment.production) console.error(message, data);
  }

  static info(message: string, data: any = null) {
    if (!environment.production) console.info(message, data);
  }

  static warn(message: string, data: any = null) {
    if (!environment.production) console.warn(message, data);
  }
}
